// extracted by mini-css-extract-plugin
export default {"root":"Carousel_root__vcCHH","swiper":"Carousel_swiper__Wl5z7","buttons":"Carousel_buttons__ToPn3","button":"Carousel_button__LIRlY"};